jQuery(document).ready(function ($) {
    $('.liee-nav-menu .menu-item.montageort').addClass('show-sub-menu');

    $('.liee-mobile-menu__burger-button').on('click', toggleMobileMenuContainer);
    $('.liee-mobile-menu__close-menu-button').on('click', toggleMobileMenuContainer);

    $('.liee-mobile-menu__menu-container .menu-item a').on('click', toggleMobileMenuContainer);
    $('.liee-mobile-menu__menu-container .menu-item a').on('click', function () {
        $('.liee-mobile-menu__menu-container .menu-item a').removeClass('active');
        $(this).addClass('active');
    });

    if ($('.liee-nav-menu .menu-item').has('.sub-menu')) {
        var spanElement = $('<span class="sub-span"></span>');
        spanElement.insertBefore($('.liee-nav-menu > li > a'));
    }

    $('.liee-nav-menu .menu-item').on('click', function (event) {
        if ($(this).hasClass('show-sub-menu')) {
            $(this).removeClass('show-sub-menu');
            return;
        }

        $('.liee-nav-menu li').removeClass('show-sub-menu');
        let class_name = event.target.className;
        $(this).toggleClass('show-sub-menu');

        if (!class_name) {
            $('.show-sub-menu + .sub-menu').show();
        }
    })

    $('.liee-mobile-menu__background-overlay').on('click', function (event) {
        $('.liee-mobile-menu').removeClass('menu-container-active');
        $(this).toggle();
    })
    function toggleMobileMenuContainer() {
        $('.liee-mobile-menu').toggleClass('menu-container-active');
        $('.liee-mobile-menu__background-overlay').toggle();
    }

    $(document).on('scroll', function (e) {
        if ($(document).scrollTop() > 20) {
            $('.mobile-menu-container').addClass('transparent');
        } else {
            $('.mobile-menu-container').removeClass('transparent');
        }
    });
});
